import React from "react";

export default function Signup() {
  return (
    <form
      // action="https://formspree.io/f/mrgvpewr"
      // method="POST"
      className="w-full"
    >
      <form className="relative w-full flex flex-col justify-center items-center md:bg-white md:px-5 md:py-2 md:rounded md:flex-row">
        <input
          required
          type="email"
          name="email"
          placeholder="Enter your mail"
          className="shadow-[0px_0px_40px_rgba(16,97,139,0.11)] md:shadow-none text-sm md:text-sm-15 outline-none py-5 px-5 md:px-0 w-full  rounded md:rounded"
        />

        <a
          href="https://reeddi.substack.com/embed"
          type="submit"
          className="hidden md:flex items-center justify-center text-center mt-4 rounded md:m-0  font-semibold bg-[#1C5B10] max-w-full lg:max-w-[182px] text-[#fff] text-sm md:text-sm-15 py-5 md:py-5 w-full md:w-[40%] px-4 md:px-8 hover:shadow-xl"
        >
          Sign Me Up
        </a>

        <a
          href="https://reeddi.substack.com/embed"
          type="submit"
          className="md:hidden flex items-center justify-center text-center rounded mt-4 md:rounded-tr md:m-0 md:rounded-br md:rounded-none font-semibold bg-[#1C5B10] max-w-full lg:max-w-[182px] text-[#fff] text-sm md:text-sm-15 py-5 md:py-5 w-full md:w-[40%] px-4 md:px-8 hover:shadow-xl"
        >
          Sign Me Up
        </a>
      </form>
    </form>
  );
}
